import React from 'react';
const stats = [{
  value: '+2.000',
  label: 'entrenadores',
  color: 'text-[#00A650]'
}, {
  value: '6x5',
  label: 'Volúmenes + Bonos',
  color: 'text-[#00A650]'
}, {
  value: '4.9/5',
  label: 'Valoración ⭐',
  color: 'text-[#00A650]'
}, {
  value: '250',
  label: 'Páginas',
  color: 'text-[#0A0A0A]'
}];
const testimonials = [{
  quote: 'Dejé de perder noches buscando ejercicios. Ahora abro Fútbol Listo 360 y armo la sesión en 5 minutos. Mi categoría U10 mejoró muchísimo.',
  name: 'Carlos M.',
  role: 'México'
}, {
  quote: 'En dos meses mis chicos pasaron de improvisar a jugar con una idea clara. La progresión por edades cambió todo.',
  name: 'Rodrigo P.',
  role: 'Argentina'
}, {
  quote: 'Tengo la temporada entera organizada de la primera a la última semana. Nunca había llegado tan tranquilo a un entrenamiento.',
  name: 'Diego S.',
  role: 'Colombia'
}];
export function SocialProofBar() {
  return <section className="w-full bg-white py-12 px-4 border-b border-[#E5E5EA]" data-id="element-168">
      <div className="max-w-5xl mx-auto" data-id="element-169">
        <div className="flex flex-wrap items-center justify-around gap-6 bg-[#FAFAFA] border border-[#E5E5EA] rounded-2xl px-6 py-6 mb-10 shadow-sm" data-id="element-170">
          {stats.map((s, i) => <div key={i} className="text-center min-w-[100px]" data-id="element-171">
              <div className={`text-3xl sm:text-4xl font-black ${s.color} tracking-tight`} data-id="element-172">
                {s.value}
              </div>
              <div className="text-[#5A5A66] text-xs sm:text-sm font-bold mt-1 uppercase tracking-wider" data-id="element-173">
                {s.label}
              </div>
            </div>)}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-174">
          {testimonials.map((t, i) => <div key={i} className="bg-white border border-[#E5E5EA] rounded-2xl p-6 shadow-sm flex flex-col" data-id="element-175">
              <div className="text-[#FFD700] text-lg mb-3" data-id="element-176">⭐⭐⭐⭐⭐</div>
              <p className="text-[#0A0A0A] text-sm sm:text-base font-medium italic flex-1 mb-4 leading-relaxed" data-id="element-177">
                "{t.quote}"
              </p>
              <div data-id="element-178">
                <div className="font-black text-[#0A0A0A] text-sm" data-id="element-179">
                  {t.name}
                </div>
                <div className="text-[#5A5A66] text-xs font-semibold" data-id="element-180">
                  {t.role}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}